import { render, staticRenderFns } from "./InvoicePayments.vue?vue&type=template&id=8d4d54dc"
import script from "./InvoicePayments.vue?vue&type=script&lang=js"
export * from "./InvoicePayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports